import { render, staticRenderFns } from "./DashboardElementsListAddEdit.vue?vue&type=template&id=771413e8&scoped=true"
import script from "./DashboardElementsListAddEdit.vue?vue&type=script&lang=js"
export * from "./DashboardElementsListAddEdit.vue?vue&type=script&lang=js"
import style0 from "./DashboardElementsListAddEdit.vue?vue&type=style&index=0&id=771413e8&prod&lang=scss"
import style1 from "./DashboardElementsListAddEdit.vue?vue&type=style&index=1&id=771413e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771413e8",
  null
  
)

export default component.exports